import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/data-platform',
    name: 'DataPlatform',
    component: () => import('@/views/DataPlatform.vue')
  },
  {
    path: '/high-precision-enhancement',
    name: 'HighPrecisionEnhancement',
    component: () => import('@/views/HighPrecisionEnhancement.vue')
  },
  {
    path: '/atmospheric-environmental-monitoring',
    name: 'AtmosphericEnvironmentalMonitoring',
    component: () => import('@/views/AtmosphericEnvironmentalMonitoring.vue')
  },
  {
    path: '/tomography',
    name: 'Tomography',
    component: () => import('@/views/Tomography.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router